import styles from 'css/src/components/public-pages/sections/EnterpriseTextSection.module.scss';

import React from 'react';

import { BUTTON_SIZES, PrimaryButton } from '../../common/ui/Button';

import { DEMO_URL } from 'js/src/libs/consts';

const EnterpriseTextSection = React.memo(function EnterpriseTextSection() {
    return (
        <div
            className={`p-l5-16 p-l5-sm-48 section-2 pb-l5-48 ${styles['enterprise-text-section']}`}
        >
            <div className="container">
                <div className="row align-items-center mt-l5-48">
                    <div className="col-md-6">
                        <h2>Set up for success with professional services</h2>
                        <p className="font-l5 font-l5--regular my-l5-16 px-l5-0 w-75">
                            Even the best tools need the right team behind them. Our Professional
                            Services experts partner with you to shape strategy, elevate
                            storytelling, and scale production. With experience across 200+ B2B
                            brands, we help you get more from Lumen5 and more from every piece of
                            content.
                        </p>
                        <PrimaryButton
                            size={BUTTON_SIZES.LG}
                            text="Explore ProServe"
                            href="https://ps.lumen5.com/"
                            className="mt-l5-16"
                        />
                    </div>
                    <div className="col-md-6">
                        <img
                            src="https://cdn.lumen5.com/lumen5-site-images/2025-website-assets/enterprise/proserve.webp"
                            className={`m-l5-48 ${styles['enterprise-text-section-image']}`}
                            loading="lazy"
                            decoding="async"
                            alt="Professional Services"
                        />
                    </div>
                </div>
                <div className="row align-items-center mt-l5-48">
                    <div className="col-md-6">
                        <img
                            src="https://cdn.lumen5.com/lumen5-site-images/2025-website-assets/enterprise/privacy.webp"
                            className={`m-l5-48 ${styles['enterprise-text-section-image']}`}
                            loading="lazy"
                            decoding="async"
                            alt="Privacy and Security"
                        />
                    </div>
                    <div className="col-md-6">
                        <h2>
                            Enterprise-grade security
                            <br />
                            you can trust
                        </h2>
                        <p className="font-l5 font-l5--regular my-l5-16 px-l5-0 w-75">
                            Security isn't an afterthought at Lumen5 — it's foundational. We've
                            passed rigorous security reviews with teams in banking, government, and
                            aerospace, so your team can create with confidence.
                        </p>
                        <ul
                            className="font-l5 font-l5--regular my-l5-16 px-l5-0"
                            style={{ paddingLeft: '1.25rem' }}
                        >
                            <li className="mb-l5-8">
                                Your data is never used to train our AI models
                            </li>
                            <li className="mb-l5-8">
                                All customer data is fully segregated — your content is never
                                accessible to other users
                            </li>
                            <li className="mb-l5-8">
                                SSO, role-based access controls, mandatory 2FA, and data encryption
                                in transit and at rest
                            </li>
                            <li className="mb-l5-8">
                                Human-in-the-loop AI — your team reviews and approves everything
                                before it's published
                            </li>
                            <li className="mb-l5-8">
                                GDPR compliant · DPA available on request · 8+ years with enterprise
                                legal and privacy teams
                            </li>
                            <li className="mb-l5-8">
                                AI governance controls to meet your internal compliance requirements
                            </li>
                        </ul>
                        <div className="d-flex align-items-center gap-3 mt-l5-16">
                            <PrimaryButton
                                size={BUTTON_SIZES.LG}
                                text="Visit our Trust Center"
                                href="https://trust.lumen5.com"
                                className=""
                            />
                            <a href={DEMO_URL} className="text-white ms-l5-16">
                                Request a demo →
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default EnterpriseTextSection;
